// extracted by mini-css-extract-plugin
module.exports = {"root":"Notice_root__JDGVI","info":"Notice_info__solOe","success":"Notice_success__QDueV","warning":"Notice_warning__4jOdP"};